import { render, staticRenderFns } from "./ChampionsMain.vue?vue&type=template&id=ac34a362&"
import script from "./ChampionsMain.vue?vue&type=script&lang=js&"
export * from "./ChampionsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports